module.exports = __webpack_public_path__ + "img/ls.85968b8b.svg";